<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">

          <h1 class="title">Profile</h1>

          <p>Welcome to Resolute.</p>

        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  computed: {
  },
  created () {
  }
}
</script>

<style lang="scss">
</style>
